import PropTypes from 'prop-types';
import React from 'react';
import Navbar from '../navbar.jsx';
import PageJump from './navbar/jump_to_page.jsx';
import SearchBox from '../searchbox.jsx';
import BookmarkButton from './navbar/bookmark_button.jsx';
import ReaderMenu from './navbar/reader_menu.jsx';
import { shouldComponentUpdate } from '../../shallow_equal';
import TOC from './navbar/toc.jsx';
import OfflineMenu from '../offline_menu.jsx';
import UserMenu from '../user_menu.ui.jsx';

import classnames from 'classnames';

class TextViewerNavbar extends React.Component {
    static propTypes = {
        chapters: PropTypes.array,
        content: PropTypes.any.isRequired,
        onNextPage: PropTypes.func.isRequired,
        onPrevPage: PropTypes.func.isRequired,
        pageLabel: PropTypes.string.isRequired,
        pagenum: PropTypes.number.isRequired,
        hideSharingQA: PropTypes.bool.isRequired,
    };

    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }

    renderPageNavButtons = () => {
        const buttons = [];

        buttons.push(
            <button
                className={classnames('icon', 'cl-icon', 'cl-icon-angle-left')}
                onClick={this.props.onPrevPage}
                key="previous"
            >
                <span className="aural">previous page</span>
            </button>
        );
        buttons.push(
            <button
                className={classnames('icon', 'cl-icon', 'cl-icon-angle-right')}
                onClick={this.props.onNextPage}
                key="next"
            >
                <span className="aural">next page</span>
            </button>
        );

        return buttons;
    };

    render() {
        return (
            <Navbar.Proxy pin={false}>
                <h1 className="aural">
                    Page {this.props.pageLabel} of {this.props.content.title}
                </h1>
                <PageJump
                    pagenum={this.props.pagenum}
                    pageLabel={this.props.pageLabel}
                    content={this.props.content}
                />
                <TOC
                    content={this.props.content}
                    chapters={this.props.chapters}
                />

                <div className="pull-right header-right">
                    <OfflineMenu toolTipDirection="left" />
                    <SearchBox contentId={this.props.content.id} />
                    <BookmarkButton
                        pagenum={this.props.pagenum}
                        content={this.props.content}
                    />
                    <ReaderMenu
                        pagenum={this.props.pagenum}
                        content={this.props.content}
                        hideSharingQA={this.props.hideSharingQA}
                    />
                    <UserMenu />
                </div>
            </Navbar.Proxy>
        );
    }
}

export default {
    // I want to make the code more obvious that we aren't rendering two navbars
    // at once, so I'm using `.Proxy` to draw attention to the fact that this
    // wrapping Navbar.Proxy instead of being a normal component.
    Proxy: TextViewerNavbar,
};



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar.jsx